import React from 'react';
import LandingGbpe from './LandingGbpe';
import LandingDefault from './LandingDefault';

/**
 * Landing - Smart router component
 * Routes to GBPE or default landing based on window.gbpe availability
 */
function Landing() {
    const hasGbpe = Boolean(window?.gbpe);

    return hasGbpe ? <LandingGbpe /> : <LandingDefault />;
}

export default Landing;